/** Development selectors describe structural alternatives, not production readiness. */
export type WorkflowStructurePresentationFlag = 'current' | 'macro-step-tori';
export type NaturalLessThanFlag = 'boolean-channel' | 'travelling-eye';
export type WheelTitlePresentationFlag = 'text' | 'flag';

export const workflowStructurePresentationFlag: WorkflowStructurePresentationFlag = 'current';
export const naturalLessThanFlag: NaturalLessThanFlag = 'boolean-channel';
export const wheelTitlePresentationFlag: WheelTitlePresentationFlag = 'flag';
